export const ALL_UPDATE = 'OPTIMIZEDINDEX/ALL/UPDATE';
export const GENERIC_UPDATE = 'OPTIMIZEDINDEX/GENERIC/UPDATE';
